import {
  QueryClient,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { addClaims } from "../../../apis";
import { SearchApiParams, Venue, VenuePinType } from "../../../types";
import { useAtom } from "jotai";
import { tagVenueSearchParamsAtom } from "../tagging";
import { Storage } from "common/storage";

export function usePostAddClaims(dontReloadVenueDetails?: boolean) {
  const accessToken = Storage.getCurrentUserToken();
  const queryClient = useQueryClient();
  const [tagVenueSearchParam] = useAtom(tagVenueSearchParamsAtom);

  const { mutate, error, status, data } = useMutation({
    mutationFn: ({
      venueId,
      name,
      email,
      phone,
      description,
      flagVenueAccessibilityId,
    }: {
      venueId: string;
      name: string;
      email: string;
      phone: string;
      description: string;
      flagVenueAccessibilityId: string | null;
    }) => {
      return addClaims(
        venueId,
        name,
        email,
        phone,
        description,
        flagVenueAccessibilityId,
        accessToken || "",
      );
    },
    onSuccess: (_, { venueId }) => {
      if (!dontReloadVenueDetails) {
        queryClient.invalidateQueries({
          queryKey: ["loadVenueDetailsBySlug"],
          exact: false,
        });
      }
    },
  });

  return { mutate, error, status, data };
}
